module.exports = __webpack_public_path__ + "static/img/5.868c3b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/5.png
// module id = fLNg
// module chunks = 0